import React, { useState, useEffect } from "react";
import { Table } from "react-materialize";
import $ from "jquery";
import config from "../../config";
import API from "../../utils/API";
import Html from "../../utils/Html";
import Func from "../../utils/Func";
import TrHead from "./main.content.trhead";
import TrContent from "./main.content.trcontent";
import SelectLimit from "./main.content.select.limit";
import SelectPage from "./main.content.select.page";
import Btn from "./main.content.btn";
import BtnAddMember from "components/employees/features/addmember/btn.addmember";
import ShowColumnBtn from "components/employees/features/showcolumn/ShowColumnBtn";
import ModalView from "components/employees/features/viewprofile/modal";
import ShowColumnModal from "components/employees/features/showcolumn/ShowColumnModal";
import ExportSheetModal from "components/employees/features/exportsheet/ExportSheetModal";
import ExportSheetBtn from "components/employees/features/exportsheet/ExportSheetBtn";
import BtnEditNotification from "components/employees/features/editnotification/btn.editnotification";
import { useAlluser } from "context/AlluserContext";


export default function TableContent({ userData }) {
  const { filters, defaultFilters, storeFilters } = useAlluser();
  const userID = userData.idu;
  const userSess = userData.user_sess;
  const defaultData = {
    data: [],
    summary_total: 0,
    total_page: 0,
    active_page: 1,
    expired_date: "",
    status: "",
    err: 0,
    err_msg: "",
  };
  const [reqData, setReqData] = useState(defaultData);
  const [actionData, setActionData] = useState({
    key: 0,
    items: [],
    checked: false,
    pages: [],
  });
  const [isOpenShowColumn, setOpenShowColumn] = useState(false);
  const [isOpenExportSheet, setOpenExportSheet] = useState(false);
  const handleEvents = {
    SelectLimit: {
      OnChange: function (evt) {
        let tmpData = Func.GetDataForm($("#form-filter").serializeArray());
        tmpData["limit"] = $(evt.target).val();
        tmpData["page"] = 1;
        storeFilters(tmpData);
        setReqData({ status: "", err: 0, err_msg: "" });
      },
    },
  };
  handleEvents.BtnShowColumn = {
    OnClick: function (evt) {
      setOpenShowColumn(!isOpenShowColumn);
    },
    OnClose: function () {
      $("body").css({ overflow: "auto" });
      setOpenShowColumn(false);
    },
  };
  handleEvents.BtnExportSheet = {
    OnClick: function (evt) {
      setOpenExportSheet(!isOpenExportSheet);
    },
    OnClose: function () {
      $("body").css({ overflow: "auto" });
      setOpenExportSheet(false);
    },
  };

  useEffect(() => {
    setReqData({ status: "processing" });
    const mainFunc = async () =>
      await API.post("alluser/data", {
        params: ({
          userID: userID,
          filters: filters,
        }),
      });
    mainFunc()
      .then((res) => {
        const decrypt = (res?.data);
        // console.log('alluser=', decrypt);
        if (decrypt?.status === "success") {
          setReqData(decrypt);
        } else {
          setReqData({ status: "", err: 1, err_msg: decrypt?.err_msg ?? "" });
        }
      })
      .catch((err) => {
        console.log(`Failes : ${err}`);
        setReqData({ status: "", err: 1, err_msg: err });
      });
  }, [filters, userID]);

  let content = "";
  if ("err" in reqData && reqData.err === 1) {
    content = (
      <div className="text-error">Fetch request error: {reqData.err_msg}</div>
    );
  } else if (reqData.status !== "success") {
    content = (
      <div>
        <Html.Preloading
          addon={{
            css: {
              position: "absolute",
              top: "150px",
              left: "0",
              right: "0",
              bottom: "0",
              margin: "auto",
            },
          }}
        />
      </div>
    );
  } else {
    //console.log("Requests", actionData);
    content = (
      <div id="table-content">
        <div id="table-total">
          <div>
            Total :{" "}
            <span id="table-total__number">{reqData.summary_total}</span>
          </div>
        </div>
        <form id="form-alluser" action="">
          <Table className="highlight" id="table-alluser">
            <thead key="thead">
              <TrHead
                data={{
                  actionData: actionData,
                  active_page: reqData.active_page,
                  userSess: userSess,
                }}
                setData={{
                  setActionData: setActionData,
                }}
              />
            </thead>
            <tbody key="tbody">
              <TrContent
                data={{
                  allUserData: reqData.data,
                  actionData: actionData,
                  userData: userData,
                }}
                setData={{
                  setActionData: setActionData,
                }}
              />
            </tbody>
          </Table>
          <input
            type="hidden"
            name="action_items"
            value={JSON.stringify(actionData.items)}
          />
          <input
            type="hidden"
            name="action_pages"
            value={JSON.stringify(actionData.pages)}
          />
          <input type="hidden" name="changed_items" value="" />
        </form>
        <SelectPage
          totalPage={reqData.total_page}
          activePage={reqData.active_page}
          setReqData={setReqData}
        />
      </div>
    );
  }
  return (
    <div id="main-content">
      <Btn
        defaultFilters={defaultFilters}
        setReqData={setReqData}
        setActionData={setActionData}
      />
      <div className="row title">
        Employees
        {Func.CheckIsAdminOrHr(userData?.user_sess) ? (
          <ExportSheetBtn handleEvents={handleEvents.BtnExportSheet} />
        ) : (
          ""
        )}
        {userSess?.userCanAccessHrAssign || userSess?.isAdmin ? (
          <ShowColumnBtn handleEvents={handleEvents.BtnShowColumn} />
        ) : (
          ""
        )}
        {userSess?.userCanAccessHrAssign || userSess?.isAdmin ? (
          <BtnAddMember />
        ) : (
          ""
        )}
        {userSess?.userCanAccessHrAssign ||
        userSess?.isAdmin ||
        userSess?.isITManager ||
        userSess?.isInfoSysManager ? (
          <BtnEditNotification />
        ) : (
          ""
        )}
        <SelectLimit limit={filters.limit} setReqData={setReqData} />
      </div>
      {content}
      <ModalView userData={userData} />
      <ShowColumnModal
        userData={userData}
        handleEvents={handleEvents}
        isOpen={isOpenShowColumn}
        setOpenShowColumn={setOpenShowColumn}
      />
      <ExportSheetModal
        userData={userData}
        handleEvents={handleEvents}
        isOpen={isOpenExportSheet}
        setOpenExportSheet={setOpenExportSheet}
        filters={filters}
      />
    </div>
  );
}

